import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import FormModalFooter from "./FormModalFooter";
import {
  FORM_CANCEL_BUTTON_SX,
  FORM_SUBMIT_BUTTON_SX,
  FORM_MODAL_FOOTER_ACTIONS_SX,
} from "../utils/formModalStyles";

/**
 * Standard centered Cancel + Submit footer for form modals/dialogs.
 * Divider above buttons matches form title header styling.
 */
const FormModalActions = ({
  onCancel,
  onSubmit,
  cancelLabel = "Cancel",
  submitLabel = "Submit",
  cancelDisabled = false,
  submitDisabled = false,
  loading = false,
  submitType = "button",
  hideCancel = false,
  hideSubmit = false,
  hideFooterDivider = false,
  beforeActions = null,
  sx = {},
}) => {
  const actions = (
    <>
      {beforeActions}
      {!hideCancel && (
        <Button
          size="small"
          onClick={onCancel}
          variant="outlined"
          color="primary"
          disabled={cancelDisabled || loading}
          sx={FORM_CANCEL_BUTTON_SX}
        >
          {cancelLabel}
        </Button>
      )}
      {!hideSubmit && (
        <Button
          size="small"
          type={submitType}
          onClick={onSubmit}
          variant="contained"
          color="primary"
          disabled={submitDisabled || loading}
          sx={FORM_SUBMIT_BUTTON_SX}
        >
          {loading ? <CircularProgress size={18} color="inherit" /> : submitLabel}
        </Button>
      )}
    </>
  );

  if (hideFooterDivider) {
    return (
      <Box sx={{ ...FORM_MODAL_FOOTER_ACTIONS_SX, width: "100%", ...sx }}>
        {actions}
      </Box>
    );
  }

  return <FormModalFooter actionsSx={sx}>{actions}</FormModalFooter>;
};

export default FormModalActions;
